export default "__VITE_ASSET__BWwfdQRu__"